import React, {useState, useEffect, useRef} from 'react';
import { Table } from 'antd';
import { TablePaginationConfig } from 'antd/lib/table';
import type { TableProps } from 'antd';

import SPTableActionBar from '../table-action-bar';

import { useCancelRuleTemplate } from 'hooks/product-price/cancel-rule-template';
import TimestampToTimeString from "../../base/timestamp-to-timeString";
import {DEFAULT_PAGE_INFO} from "../../../../consts";
import {mergeObjects} from "../../../../utils";
import emiter, {_EVENTS} from "../../../../events";

interface IComponentProps {
  enums?: any;
  permission?: any;
}
interface ICancelRuleTemplateTableDataType {
    key?: any;
    id?: any;
    name?: any;
    state?: any;
    createDate?: any;
};
const SPTable: React.FC<IComponentProps> = (props) => {
  const { enums, permission } = props;

  const columns: TableProps<ICancelRuleTemplateTableDataType>['columns'] = [
      // { title: '供应商名称', dataIndex: 'supplier_name', key: 'supplier_name' },
      { title: '模版名称', dataIndex: 'name', key: 'name' },
      { title: '更新时间', dataIndex: 'price', render: (_, record) =>  (<TimestampToTimeString data={record} timeKeyPath={'updater.update_time'}></TimestampToTimeString>)},
      { title: '操作', className: 'common-tab-action-bar', key: 'action', render: (_, record) => (<SPTableActionBar permission={permission} data={record} />) },
  ];

  const [data, setData] = useState<any>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPageData, setCurrentPageData] = useState<any>();
    const dataRef = useRef({});

  const { search, tablePagination, onSearchAction } = useCancelRuleTemplate();

  const load = (params?: any) => {
      params = Object.assign({...DEFAULT_PAGE_INFO}, {...dataRef.current}, params);
      search(params).then((data: any) => {
          const res = data?.data
          setData(res?.list || []);
          setTotalCount(res?.total);
          dataRef.current = params
          setCurrentPageData({page: res.page || 1, page_size: res.page_size || 10});
      })
  };

  // TODO: 清空再搜索，翻页有问题
  const onPagination = (pagination: TablePaginationConfig) => {
    tablePagination(Object.assign(dataRef.current, {
        page: pagination.current,
        page_size: pagination.pageSize
    }))
  };

  useEffect(() => {
      emiter.on(_EVENTS.PRODUCT_PRICE.CANCEL_RULE.SEARCH, load);
      return () => {
          emiter.removeAllListeners(_EVENTS.PRODUCT_PRICE.CANCEL_RULE.SEARCH)
      }
  }, []);

  return (
    <>
        <Table
            columns={columns}
            dataSource={data}
            rowKey={cols => cols.id}
            pagination={{ total:totalCount, showSizeChanger: true, showQuickJumper: true,showTotal:total => `共 ${total} 条数据`,current:currentPageData?.page,pageSize:currentPageData?.page_size }}
            onChange={onPagination}
          />
    </>
  );
};

export default SPTable;

